export enum BankAccountType {
    SAVINGS = 'SAVINGS',
    CURRENT = 'CURRENT',
    FIXED_DEPOSIT = 'FIXED_DEPOSIT',
    TAX_FREE_DEPOSIT = 'TAX_FREE_DEPOSIT',
    HIGH_YIELD_SAVINGS = 'HIGH_YIELD_SAVINGS',
    ONLINE_SAVINGS = 'ONLINE_SAVINGS',
}

export const BankAccountTypeOptions = [
    { label: 'บัญชีออมทรัพย์ — Savings Account', value: BankAccountType.SAVINGS }, // i18n-ignore: display label, translated at render site with t(label)
    { label: 'บัญชีกระแสรายวัน — Current Account', value: BankAccountType.CURRENT }, // i18n-ignore: display label, translated at render site with t(label)
    { label: 'บัญชีเงินฝากประจำ — Fixed Deposit Account', value: BankAccountType.FIXED_DEPOSIT }, // i18n-ignore: display label, translated at render site with t(label)
    { label: 'บัญชีเงินฝากปลอดภาษี — Tax-Free Deposit Account', value: BankAccountType.TAX_FREE_DEPOSIT }, // i18n-ignore: display label, translated at render site with t(label)
    { label: 'บัญชีเงินฝากออมทรัพย์พิเศษ — High-Yield Savings Account', value: BankAccountType.HIGH_YIELD_SAVINGS }, // i18n-ignore: display label, translated at render site with t(label)
    { label: 'บัญชีเงินฝากออนไลน์ — Online Savings Account', value: BankAccountType.ONLINE_SAVINGS }, // i18n-ignore: display label, translated at render site with t(label)
];


export interface Bank {
    name: string
    fullname: string
    nameEN: string
    symbol: string
    icon: string
    color: string
}

export interface BankList {
    [key: string]: Bank
}



export const bankListArray = [
    {
        name: "กสิกรไทย", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารกสิกรไทย",
        nameEN: "Kasikorn Bank",
        symbol: "KBANK",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KBANK.png",
        color: "#1DA858"
    },
    {
        name: "ไทยพาณิชย์", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารไทยพาณิชย์",
        nameEN: "The Siam Commercial Bank",
        symbol: "SCB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/SCB.png",
        color: "#543186"
    },
    {
        name: "กรุงไทย", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารกรุงไทย",
        nameEN: "Krungthai Bank",
        symbol: "KTB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KTB.png",
        color: "#1DA8E6"
    },
    {
        name: "กรุงเทพ", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารกรุงเทพ",
        nameEN: "Bangkok Bank",
        symbol: "BBL",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BBL.png",
        color: "#29449D"
    },
    {
        name: "กรุงศรีอยุธยา", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารกรุงศรีอยุธยา",
        nameEN: "Krungsri Bank",
        symbol: "BAY",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BAY.png",
        color: "#FFD51C"
    },
    {
        name: "ทีเอ็มบีธนชาต", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารทีเอ็มบีธนชาต",
        nameEN: "TMBThanachart Bank",
        symbol: "TTB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TTB.png",
        color: "#0C55F2"
    },
    {
        name: "ยูโอบี", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารยูโอบี",
        nameEN: "United Overseas Bank",
        symbol: "UOB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/UOB.png",
        color: "#E41A26"
    },
    {
        name: "เกียรตินาคิน", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารเกียรตินาคินภัทร",
        nameEN: "Kiatnakin Phatra Bank",
        symbol: "KKP",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/KKP.png",
        color: "#5A547C"
    },
    {
        name: "ออมสิน", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารออมสิน",
        nameEN: "Government Savings Bank",
        symbol: "GSB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/GSB.png",
        color: "#ED1891"
    },
    {
        name: "ธ.ก.ส.", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        nameEN: "Bank for Agriculture and Agricultural Cooperatives",
        symbol: "BAAC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/BAAC.png",
        color: "#CCA41C"
    },
    {
        name: "ซีไอเอ็มบี", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารซีไอเอ็มบี",
        nameEN: "CIMB Thai Bank",
        symbol: "CIMB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/CIMB.png",
        color: "#BD1325"
    },
    {
        name: "ซิตี้แบงก์", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารซิตี้แบงก์",
        nameEN: "citibank",
        symbol: "CITI",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/CITI.png",
        color: "#0F3D89"
    },
    {
        name: "ธ.อ.ส.", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารอาคารสงเคราะห์",
        nameEN: "GH Bank",
        symbol: "GHB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/GHB.png",
        color: "#FF8614"
    },
    {
        name: "เอชเอสบีซี", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารเอชเอสบีซี",
        nameEN: "HSBC Bank",
        symbol: "HSBC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/HSBC.png",
        color: "#FF1518"
    },
    {
        name: "อิสลามแห่งประเทศไทย", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารอิสลามแห่งประเทศไทย",
        nameEN: "Islamic Bank of Thailand",
        symbol: "IBANK",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/IBANK.png",
        color: "#164626"
    },
    {
        name: "ไอซีบีซี", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารไอซีบีซี",
        nameEN: "ICBC Thai Commercial Bank",
        symbol: "ICBC",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/ICBC.png",
        color: "#CD1511"
    },
    {
        name: "แลนด์ แอนด์ เฮ้าส์", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        nameEN: "LH Bank",
        symbol: "LHB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/LHB.png",
        color: "#727375"
    },
    {
        name: "ไทยเครดิต", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารไทยเครดิต",
        nameEN: "Thai Credit Bank",
        symbol: "TCRB",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TCRB.png",
        color: "#FF7813"
    },
    {
        name: "ทิสโก้", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ธนาคารทิสโก้",
        nameEN: "Tisco Bank",
        symbol: "TISCO",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TISCO.png",
        color: "#267CBC"
    },
    {
        name: "พร้อมเพย์", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "พร้อมเพย์",
        nameEN: "PromptPay",
        symbol: "PromptPay",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/PromptPay.png",
        color: "#0C4370"
    },
    {
        name: "ทรูมันนี่", // i18n-ignore: bank master data (name/fullname matched with bank_name_th); English shown from nameEN
        fullname: "ทรูมันนี่",
        nameEN: "True Money",
        symbol: "TrueMoney",
        icon: "https://raw.githubusercontent.com/casperstack/thai-banks-logo/master/icons/TrueMoney.png",
        color: "#EE252B"
    }
];